module.exports = __webpack_public_path__ + "static/media/brunch1.4db5d711.png";